export enum Environment {
    DEV = "DEV", 
    PRE = "PRE"
}